module.exports = __webpack_public_path__ + "img/login_bg.b8ec40b0.png";